 import styled from "styled-components";
 
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
  width: 100%;
  height: 100%;
  row-gap: 1vh;
  margin-top: 1vh;
  text-align: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  column-gap: 2vw;
`;

 